import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface IDocumentType {
    value: string;
    label: string;
}

@Injectable({
  providedIn: 'root'
})
export class DocumentTypeService {

    documentsTypes: IDocumentType[] = [
        { value: 'CD', label: 'Carné diplomático'},
        { value: 'CC', label: 'Cédula de ciudadanía'},
        { value: 'CE', label: 'Cédula de extranjería'},
        { value: 'CR', label: 'Certificado registraduría sin identificación'},
        { value: 'DIE', label: 'Documento de identificación extranjero'},
        { value: 'EXJ', label: 'Documento de identificación extranjeros persona jurídica'},
        { value: 'RC', label: 'Registro civil de nacimiento'},
        { value: 'DFD', label: 'Sin identificación del exterior o para uso definido DIAN'},
        { value: 'TE', label: 'Tarjeta de extranjería'},
        { value: 'TI', label: 'Tarjeta de identidad'},
        { value: 'PS', label: 'Pasaporte'},
        { value: 'PEP', label: 'Permiso especial de permanencia PEP'},
        { value: 'PPT', label: 'Permiso por protección temporal PPT'},
    ];

    constructor() {}

    getDocumentTypes(): Observable<IDocumentType[]> {
      return of(this.documentsTypes);
    }
}
